export default "__VITE_ASSET__43bb4e43__"